// Seramik Mock Data
// Seramik/fayans malzemeleri, desen ve stok takibi

export const seramikMalzemeler = [
    {
        id: 'sr-001',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Kaleseramik',
        tedarikciFirmaId: 'f-090',
        kategori: 'yer-seramik',
        urunAdi: 'Elegance Gri',
        aciklama: '60x60 Mat Yer Seramiği',
        desen: 'Mermer Görünüm',
        ebat: '60x60 cm',
        miktar: 500,
        birim: 'm²',
        birimFiyat: 280,
        toplamFiyat: 140000,
        durum: 'teslim',
        stokMiktar: 150,
        kullanilanMiktar: 350,
        uygulamaYeri: 'A Blok Daireler',
        insaatId: 'c-001',
        not: 'Salon ve odalar',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-17T15:00:00Z',
    },
    {
        id: 'sr-002',
        siparisTarihi: '2026-01-10',
        teslimTarihi: '2026-01-12',
        tedarikci: 'Vitra',
        tedarikciFirmaId: 'f-091',
        kategori: 'duvar-fayans',
        urunAdi: 'Bathroom White',
        aciklama: '30x60 Parlak Fayans',
        desen: 'Düz Beyaz',
        ebat: '30x60 cm',
        miktar: 200,
        birim: 'm²',
        birimFiyat: 220,
        toplamFiyat: 44000,
        durum: 'teslim',
        stokMiktar: 40,
        kullanilanMiktar: 160,
        uygulamaYeri: 'A Blok Banyolar',
        insaatId: 'c-001',
        not: 'Banyo duvarları',
        createdAt: '2026-01-10T09:00:00Z',
        updatedAt: '2026-01-16T16:00:00Z',
    },
    {
        id: 'sr-003',
        siparisTarihi: '2026-01-08',
        teslimTarihi: '2026-01-09',
        tedarikci: 'Kaleseramik',
        tedarikciFirmaId: 'f-090',
        kategori: 'yer-seramik',
        urunAdi: 'Granit Antrasit',
        aciklama: '40x40 Dış Mekan',
        desen: 'Pürüzlü',
        ebat: '40x40 cm',
        miktar: 150,
        birim: 'm²',
        birimFiyat: 180,
        toplamFiyat: 27000,
        durum: 'teslim',
        stokMiktar: 0,
        kullanilanMiktar: 150,
        uygulamaYeri: 'A Blok Balkon',
        insaatId: 'c-001',
        not: 'Balkon zeminleri tamamlandı',
        createdAt: '2026-01-08T10:00:00Z',
        updatedAt: '2026-01-14T17:00:00Z',
    },
    {
        id: 'sr-004',
        siparisTarihi: '2026-01-15',
        teslimTarihi: null,
        tedarikci: 'Ege Seramik',
        tedarikciFirmaId: 'f-092',
        kategori: 'bordur',
        urunAdi: 'Geometrik Bordür',
        aciklama: '8x60 Dekoratif',
        desen: 'Geometrik',
        ebat: '8x60 cm',
        miktar: 100,
        birim: 'metre',
        birimFiyat: 45,
        toplamFiyat: 4500,
        durum: 'bekliyor',
        stokMiktar: 0,
        kullanilanMiktar: 0,
        uygulamaYeri: 'A Blok Banyolar',
        insaatId: 'c-001',
        not: 'Dekor için sipariş',
        createdAt: '2026-01-15T11:00:00Z',
        updatedAt: '2026-01-15T11:00:00Z',
    },
];

// Seramik kategorileri
export const seramikKategorileri = [
    { key: 'yer-seramik', label: 'Yer Seramiği', icon: '🔲' },
    { key: 'duvar-fayans', label: 'Duvar Fayansı', icon: '🧱' },
    { key: 'bordur', label: 'Bordür', icon: '📏' },
    { key: 'mozaik', label: 'Mozaik', icon: '🎨' },
];

// İstatistikler
export const getSeramikStats = (insaatId) => {
    const filtered = insaatId
        ? seramikMalzemeler.filter(s => s.insaatId === insaatId)
        : seramikMalzemeler;

    const toplamKalem = filtered.length;
    const teslimEdilen = filtered.filter(s => s.durum === 'teslim').length;
    const toplamMaliyet = filtered.reduce((acc, s) => acc + s.toplamFiyat, 0);
    const toplamMetrekare = filtered.reduce((acc, s) => acc + (s.birim === 'm²' ? s.miktar : 0), 0);
    const stokMetrekare = filtered.reduce((acc, s) => acc + (s.birim === 'm²' ? s.stokMiktar : 0), 0);

    return { toplamKalem, teslimEdilen, toplamMaliyet, toplamMetrekare, stokMetrekare };
};

// Helper: insaata göre filtrele
export const getSeramikByInsaat = (insaatId) => {
    if (!insaatId) return seramikMalzemeler;
    return seramikMalzemeler.filter(s => s.insaatId === insaatId);
};
